// https://www.apollographql.com/docs/react/data/queries/#supported-fetch-policies
enum ApolloFetchPolicies {
  CACHE_FIRST = 'cache-first',
  CACHE_ONLY = 'cache-only',
  CACHE_AND_NETWORK = 'cache-and-network',
  NETWORK_ONLY = 'network-only',
  NO_CACHE = 'no-cache', // dont use - it disables watchLoading and loading property....
  STANDBY = 'standby',
}

export default ApolloFetchPolicies
